import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { useNotificationStore } from '@/stores/notifications';
import { queryClient } from '@/lib/react-query';

export const useUpdateColumnDetails = ({ config } = {}) => {
  const { addNotification } = useNotificationStore();

  return useMutation(
    ({ data = {}, integId = '', tableId = '', columnName = '' }) =>
      axios.put(
        `/api/v1/integration/data-dictionaries/${integId}/${tableId}/${columnName}`,
        data
      ),
    {
      ...config,
      onError: (error) => {
        addNotification({
          type: 'error',
          title: error.response?.data?.error?.message || error.message,
        });
      },
      onSuccess: (_, { tableId, searchQuery, columnName }) => {
        addNotification({
          type: 'success',
          title: `${columnName} updated successfully.`,
        });
        queryClient.refetchQueries(['tableColumns', tableId, searchQuery, 1]);
        queryClient.refetchQueries('getConnectedDefinitionsList');
      },
      ...config,
    }
  );
};
